import { render, staticRenderFns } from "./PhotoInfo.vue?vue&type=template&id=5f9e7185&"
import script from "./PhotoInfo.ts?vue&type=script&lang=ts&"
export * from "./PhotoInfo.ts?vue&type=script&lang=ts&"
import style0 from "./PhotoInfo.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports